module.exports = __webpack_public_path__ + "img/cover.cbec783a.jpg";